import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainTemplate from "../mainTemplate";
import AdminTable from "../../shared/table";
import { ReactTitle } from "react-meta-tags";
import { useTranslation } from "react-i18next";
import Modal from "../../utils/customModal";
import FilterComponent from "../../utils/searchBar";
import { useDispatch, useSelector } from "react-redux";
import { getRoles } from "../../../Redux/reducer/session";
import {
  loadingHtml,
  moduleAction,
  infoContainer,
  errorContainer,
} from "../../utils/functions";
import { getAllNotifications } from "../../../Redux/actions/notificationsAction";
import {
  getNotifications,
  getTotalElements,
} from "../../../Redux/reducer/notifications";
import { MOD_PARAM, WRITE } from "../../../permissions";
import plusImage from "../../../../static/images/plus.svg";
import NotificationsIco from "../../../../static/images/notifications-black.svg";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconShow from "canvas-core-react/lib/IconShow";
import IconDelete from "canvas-core-react/lib/IconDelete";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import i18next from "i18next";
import useApi from "../../hooks/useApi";

const filters = [
  {
    name: `${i18next.t("general.placeholders.name")}`,
    property: `nameTypeNotificationEmail${i18next.language
      .charAt(0)
      .toUpperCase()}${i18next.language.slice(1)}`,
    operator: "eq",
  },
];

const Notifications = () => {
  const { t } = useTranslation();
  const { postApiCAll } = useApi();
  const [modal, setModal] = useState({
    loading: false,
    show: false,
    content: null,
  });
  const [menus, setMenus] = useState([]);
  const [page, setPage] = useState(0);

  const roles = useSelector((state) => getRoles(state));
  const notifications = useSelector((state) => getNotifications(state));
  const totalElements = useSelector((state) => getTotalElements(state));

  const dispatch = useDispatch();

  useEffect(() => {
    fetchData({ page: 0 });
  }, []);

  const fetchData = async ({
    page = 0,
    sizePerPage = 10,
    customFilters = [],
  }) => {
    setModal({ content: loadingHtml(), show: true });
    try {
      await dispatch(getAllNotifications(page, sizePerPage, customFilters));
      setPage(page);
      setModal({ content: null, show: false });
    } catch (error) {
      const message = error.response.data.notifications[0].description;
      const buttons = {
        continueBtn: {
          text: "Aceptar",
          action: () => fetchData({ page: 0 }),
        },
      };
      const content = errorContainer("", message, buttons);
      setModal({ content, show: true });
    }
  };

  const handleMenu = (id, open) => {
    const tmpMenus = [...menus];
    tmpMenus[`menu-${id}`] = open;
    setMenus(tmpMenus);
  };

  const getSearchResult = (property, value = "") => {
    var actionFilters = [];

    if (value !== "") {
      var operator = "";
      filters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });
      actionFilters = [
        { property: property, operator: operator, value: value },
      ];
    }

    fetchData({
      page: 0,
      sizePerPage: 10,
      customFilters: actionFilters,
    });
  };

  const getTableColumns = () => {
    return [
      { selector: "name", name: t("notification.form.table_title") },
      { selector: "date", name: t("notification.form.table_creation") },
      { selector: "status", name: t("notification.form.table_status") },
      {
        selector: "action",
        name: `${t("providers.table.headers.action")}`,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.id}`] || false}
            setIsMenuOpen={(open) => handleMenu(row.id, open)}
          >
            <ActionMenuListItem
              link={{ href: `/bscadministrator/notifications/edit/${row.id}` }}
              icon={() => <IconShow className="TextButton__icon--left" />}
            >
              Editar
              {/* {t("general.labels.viewProfile")} */}
            </ActionMenuListItem>
            <ActionMenuListItem
              onClick={() => {
                setMenus([]);

                closeStep(row);
              }}
              icon={() => <IconDelete className="TextButton__icon--left" />}
            >
              Borrar
              {/* {t("general.labels.viewProfile")} */}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  };

  const getData = () => {
    var data = [];
    if (notifications.length > 0) {
      notifications.map((item) => {
        data.push({
          id: item.id,
          name: item.nameTypeNotificationEmailTraslade,
          status: item.isDeleted === true ? "INACTIVO" : "ACTIVO",
          date: new Date(item.createDate).toLocaleDateString("es-ES"),
        });
      });
    }

    return data;
  };

  const deleteNotification = async (row) => {
    setModal({ content: loadingHtml(), show: true });
    try {
      const response = await postApiCAll("/type-notification-emails/deleted", [
        { idDeleted: row.id },
      ]);

      const buttons = {
        formBtn: {
          text: "Aceptar",
          action: () => fetchData({ page: 0 }),
        },
      };

      const { message, saved } = response.data?.data?.details[0];
      const content = infoContainer(
        t(`general.modal.${!saved ? "errorChanges" : "appliedChanges"}`),
        message,
        buttons
      );
      setModal({ content, show: true });
    } catch (error) {
      fetchData({ page: 0 });
    }
  };

  const closeDelete = () => {
    setModal({ show: false, content: null });
  };

  const closeStep = (row) => {
    const buttons = {
      SelBtn: {
        text: "Borrar",
        action: () => deleteNotification(row),
      },
      formBtn: {
        text: "Salir",
        action: closeDelete,
      },
    };

    const content = infoContainer(
      "Eliminar Notificación",
      `¿Esta por borrar la notificación ${row.name}?`,
      buttons
    );
    setModal({ content, show: true });
  };

  return (
    <MainTemplate>
      <ReactTitle title={`Notificaciones - Reverse Factoring`} />
      <div className="header-title flex-element">
        <div className="title gest-client flex-element">
          <img src={NotificationsIco} />
          <div className="client-gest">
            {t("notification.table.headers.header")}
          </div>
        </div>
        <div className="actions flex-element">
          {moduleAction(roles, MOD_PARAM, WRITE) && (
            <Link
              to="/bscadministrator/notifications/add"
              className="add-button flex-element"
            >
              <p className="bsc-add-client">
                {t("notification.table.headers.add")}
              </p>
              <img src={plusImage} />
            </Link>
          )}
          <div className="filter">
            <FilterComponent filter={filters} searchFnc={getSearchResult} />
          </div>
        </div>
      </div>
      <AdminTable
        headers={getTableColumns()}
        data={getData()}
        page={page}
        totalSize={totalElements}
        sizePerPage={10}
        onTableChange={fetchData}
      />
      <Modal show={modal.show} id="add-user-modal">
        <div className="molda-setting-content">{modal.content}</div>
      </Modal>
    </MainTemplate>
  );
};

export default Notifications;
